import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMsal, useAccount } from "@azure/msal-react";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import authConfig from "../../authConfig";

function AddFormPopup({ onAdded, label="Add Form" }) {
    const { t } = useTranslation();
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});
    const [show, setShow] = useState(false);
    const [name, setName] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    
    const handleShow = () => {
        setName("");
        setError(null);
        setShow(true);
    };
    const handleClose = () => {
        setShow(false);
        setError(null);
    };

    const handleSave = async () => {
        setError(null);
        if (!name || loading) return;
        setLoading(true);
        try {
            const tokenResponse = await instance.acquireTokenSilent({
                scopes: authConfig.api.scopes,
                account: account
            });
            const client = axios.create({
                headers: { Authorization: `Bearer ${tokenResponse.accessToken}` }
            });
            const res = await client.post(authConfig.api.urls.getMemberFormAdd, { name });
            const newId = res?.data;
            if (onAdded) onAdded(newId);
            setLoading(false);
            setShow(false);
        } catch (err) {
            console.error(err);
            setError(err?.message || "Error saving form");
            setLoading(false);
        }
    };

    return (
        <>
            <Button variant="success" onClick={handleShow}>
                 { t(label) }
            </Button>

            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Add Member Form")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="addFormName">
                            <Form.Label>{t("Form name")}</Form.Label>
                            <Form.Control
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder={t("Enter a name for the form")}
                                autoFocus
                            />
                        </Form.Group>
                        {error ? <div className="text-danger mt-2">{error}</div> : null}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose} disabled={loading}>
                        {t("Cancel")}
                    </Button>
                    <Button variant="success" onClick={handleSave} disabled={!name || loading}>
                        {loading ? t("Saving...") : t("Save")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddFormPopup;